// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type ProspectEmployeeCensus } from 'components/prospects/types'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function useCreateManualCensus ({ prospectId }: { prospectId: string }) {
  return useMutation<ProspectEmployeeCensus, GrapeAPIErrorType, void>({
    mutationFn: async () => {
      const request = new FetchRequest(
        'post',
        `/api/web/quoting/prospects/${prospectId}/census/manual`,
        {
          body: {},
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
